<template>
  <el-dialog
    title="申请退款"
    :visible.sync="isShow"
    destroy-on-close
    width="800px"
    @close="closeDialog"
  >
    <el-form ref="applyForm" :model="formData" :rules="rules" label-width="110px">
      <div class="rj-row">
        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              电汇编号：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.telegraphicTransferNum }}
            </div>
          </div>
        </div>

        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              可用余额：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.unusedAmount }}元
            </div>
          </div>
        </div>

        <div class="rj-col-1">
          <div class="rj-baseinfo">
            <div class="rj-baseinfo__label">
              币种：
            </div>
            <div class="rj-baseinfo__item">
              {{ formData.currency || '-' }}
            </div>
          </div>
        </div>

        <div class="rj-col-1 mb-10">
          <div class="rj-baseinfo">
            <el-form-item
              label="退款金额："
              prop="returnAmount"
            >
              <el-input-number
                v-model.number="formData.returnAmount"
                :precision="2"
                :step="1"
                :min="0"
                placeholder="请输入退款金额"
              />
            </el-form-item>
          </div>
        </div>

        <div class="rj-col-1 mb-10">
          <div class="rj-baseinfo">
            <el-form-item label="收款单位：" prop="payee">
              <el-input
                v-model="formData.payee"
                placeholder="请输入退款理由"
              />
            </el-form-item>
          </div>
        </div>

        <div class="rj-col-1 mb-10">
          <div class="rj-baseinfo">
            <el-form-item label="银行账号：" prop="bankAccount">
              <el-input
                v-model="formData.bankAccount"
                placeholder="请输入银行账号"
              />
            </el-form-item>
          </div>
        </div>

        <div class="rj-col-1 mb-10">
          <div class="rj-baseinfo">
            <el-form-item label="开户行：" prop="openBank">
              <el-select
                v-if="isCny"
                v-model="formData.openBank"
                style="width: 100%;"
                filterable
                remote
                clearable
                :remote-method="searchCustomerBankBranches"
                :loading="bankBranchLoading"
                placeholder="请输入开户行"
                @change="handleBankBranchChange"
              >
                <el-option
                  v-for="branch in customerBankBranches"
                  :key="branch.branchNo"
                  :label="branch.branchName"
                  :value="branch.branchName"
                />
              </el-select>
              <el-input
                v-else
                v-model="formData.openBank"
                placeholder="请输入开户行"
              />
            </el-form-item>
          </div>
        </div>

        <div class="rj-col-1 mb-10">
          <div class="rj-baseinfo">
            <el-form-item label="客户联行号：" prop="customerBankNo">
              <el-input
                v-model="formData.customerBankNo"
                placeholder="请输入客户联行号"
              />
            </el-form-item>
          </div>
        </div>

        <div class="rj-col-1 mb-10">
          <div class="rj-baseinfo">
            <el-form-item label="SWIFT CODE：" prop="swiftCode">
              <el-input
                v-model="formData.swiftCode"
                placeholder="请输入SWIFT CODE"
              />
            </el-form-item>
          </div>
        </div>

        <div class="rj-col-1 mb-10">
          <div class="rj-baseinfo">
            <el-form-item label="退款理由：" prop="reason">
              <el-input
                v-model="formData.reason"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 8 }"
                placeholder="请输入退款理由"
                maxlength="3000"
                show-word-limit
              />
            </el-form-item>
          </div>
        </div>
      </div>
    </el-form>

    <div class="rj-page-card__title" style="margin-top: 15px">
      审批记录
    </div>

    <el-table
      :data="tableData"
      border
      height="180"
    >
      <el-table-column prop="approver" label="审批人" align="left" />
      <el-table-column prop="approvalOpinion" label="审批意见" align="left" />
      <el-table-column prop="approvalTime" label="审批时间" align="left" />
    </el-table>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="mini" :loading="isLoading" @click="submitData">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getRefundApplyInfo, searchCustomerBankBranches as searchCustomerBankBranchesApi, editRefund } from '@/API/index.js';

export default {
  data () {
    var checkRefundAmont = (rule, value, callback) => {
      setTimeout(() => {
        if (value <= 0) {
          callback(new Error('退款金额不能小于等于0'));
        } else {
          if (value > this.formData.unusedAmount) {
            callback(new Error('不能大于可用金额'));
          } else {
            callback();
          }
        }
      }, 100);
    };
    var checkBankInfo = (rule, value, callback) => {
      if (this.isCny && !this.formData.customerBankNo) {
        callback(new Error('客户联行号不能为空'));
      } else if (!this.formData.customerBankNo && !this.formData.swiftCode) {
        callback(new Error('客户联行号和SWIFT CODE不能同时为空'));
      } else {
        callback();
      }
    };

    return {
      isShow: false,
      formData: {},
      telApprovalId: '',
      currency: '',
      customerBankBranches: [],
      bankBranchLoading: false,
      bankBranchRequestId: 0,
      rules: {
        returnAmount: [
          { required: true, message: '退款金额不能为空' },
          { validator: checkRefundAmont, trigger: 'blur' }
        ],
        payee: [{ required: true, message: '收款单位不能为空' }],
        bankAccount: [{ required: true, message: '银行账号不能为空' }],
        openBank: [{ required: true, message: '开户行不能为空' }],
        customerBankNo: [{ validator: checkBankInfo, trigger: 'blur' }],
        swiftCode: [{ validator: checkBankInfo, trigger: 'blur' }],
        reason: [{ required: true, message: '退款理由不能为空' }]
      },
      tableData: [],
      isLoading: false
    };
  },

  computed: {
    isCny () {
      return String(this.currency).toUpperCase() === 'CNY';
    }
  },

  methods: {
    openDialog ({ telApprovalId }) {
      this.telApprovalId = telApprovalId;
      this.isShow = true;
      this.queryData(telApprovalId);
    },

    closeDialog () {
      this.isShow = false;
      this.$refs.applyForm.resetFields();
      this.formData = {};
      this.currency = '';
      this.customerBankBranches = [];
      this.bankBranchRequestId += 1;
      this.bankBranchLoading = false;
    },

    async searchCustomerBankBranches (query) {
      const branchName = (query || '').trim();
      const requestId = ++this.bankBranchRequestId;
      if (!branchName) {
        this.customerBankBranches = [];
        this.bankBranchLoading = false;
        return;
      }
      this.bankBranchLoading = true;
      try {
        const res = await searchCustomerBankBranchesApi(branchName);
        if (requestId === this.bankBranchRequestId) {
          const { status, data } = res.data;
          this.customerBankBranches = status === '200' && Array.isArray(data) ? data : [];
        }
      } catch (error) {
        if (requestId === this.bankBranchRequestId) {
          this.customerBankBranches = [];
        }
      } finally {
        if (requestId === this.bankBranchRequestId) {
          this.bankBranchLoading = false;
        }
      }
    },

    handleBankBranchChange (branchName) {
      const branch = this.customerBankBranches.find(item => item.branchName === branchName);
      this.formData.customerBankNo = branch ? branch.branchNo : '';
    },

    queryData (id) {
      getRefundApplyInfo({ telApprovalId: id }).then((res) => {
        let { status, data } = res.data;
        if (status === '200') {
          this.tableData = data.approvalRecords || [];
          this.currency = data.currency || '';
          this.formData = {
            telegraphicTransferNum: data.telegraphicTransferNum,
            currency: data.currency,
            unusedAmount: data.unusedAmount,
            returnAmount: data.returnAmount,
            payee: data.payee,
            bankAccount: data.bankAccount,
            openBank: data.openBank,
            customerBankNo: data.customerBankNo,
            swiftCode: data.swiftCode,
            reason: data.reason
          };
          this.customerBankBranches = this.isCny && data.openBank
            ? [{ branchName: data.openBank, branchNo: data.customerBankNo }]
            : [];
        }
      });
    },

    submitData () {
      this.$refs.applyForm.validate((vaild) => {
        if (vaild) {
          this.isLoading = true;
          let params = {
            ...this.formData,
            telApprovalId: this.telApprovalId
          };
          editRefund(params)
            .then((res) => {
              this.isLoading = false;
              let { status, data } = res.data;
              if (status === '200') {
                this.closeDialog();
                this.$emit('on-ok', data);
              }
            }).catch(() => {
              this.isLoading = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.rj-baseinfo{
  width: 100%;
  .el-form-item{
    width: 100%;
  }
}
</style>
